<template>
    <BaseModalTemplate
            :title="modal_title"
            :open-close-dialog="open_modal"
            :loading="false"
            card_extra_classes="modal-width-xs"
            body_extra_classes="custom-height"
            :sendForm="sendForm"
    >
        <template #body-modal-content>
            <v-row>
                <v-col cols="12">
                    <span class="input-title">Nombre</span>
                    <v-text-field
                            placeholder="Nombre"
                            class="input-error text-field-primary"
                            :error="form_errors.name"
                            v-model.trim="sf_type_data.name"
                            variant="underlined"
                            hide-details
                    >
                    </v-text-field>
                    <span v-if="form_errors.name"
                          class="input-error msg-error"
                    >
                        El campo no puede estar vacío
                    </span>
                </v-col>
                <v-col cols="12" v-if="action === 'update'">
                    <span class="input-title">Estado</span>
                    <div style="display: inline-block; width: auto ">
                        <v-checkbox
                                label="Activo"
                                v-model="sf_type_data.active"
                                :true-value="1"
                                :false-value="0"
                                :color="'#AD7BE9'"
                                hide-details
                                :disabled="!sf_type_data.is_safe_deactivate"
                        >
                        </v-checkbox>
                    </div>
                    <span
                        v-if="!sf_type_data.is_safe_deactivate"
                        class="input-error msg-error"
                    >
                            No se puede desactivar el tipo ya que esta asignado a una fuerza de ventas activa
                        </span>
                </v-col>
                <v-col cols="12" v-else>
                    <span class="input-title">Estado</span>
                    <div style="display: inline-block; width: auto ">
                        <v-checkbox
                            label="Activo"
                            v-model="sf_type_data.active"
                            :true-value="1"
                            :false-value="0"
                            :color="'#AD7BE9'"
                            hide-details
                        >
                        </v-checkbox>
                    </div>
                </v-col>
            </v-row>
        </template>
    </BaseModalTemplate>
</template>

<script>
import BaseModalTemplate from "@/components/Generic/BaseModalTemplate.vue";
import {onBeforeMount, ref} from "vue";
import {manageWSResponses, showNotification, variableIsDefined} from "@/utils/aux_functions";
import {insertSFTypeWS, updateSFTypeWS} from "@/utils/sf_types";

export default {
    name: "ManageSFTypesModal",
    components: {BaseModalTemplate},
    props: {
        open_modal: Function,
        reloadData: Function,

        action: String, //Indica si el modal se usará para insertar un valor o para actualizar
        selected_type: Object, //Si el modal se usará para actualizar debe de haber un ID del elemento a actualizar
    },
    setup(props) {
        let loading = ref(false)
        let sf_type_data = ref({})
        let form_errors = ref({})
        let modal_title = ref("Añadir nuevo tipo")

        onBeforeMount(() => {
            if (props.action === 'update'){
                sf_type_data.value = { ...props.selected_type};
                modal_title.value = `Actualización del tipo con ID ${sf_type_data.value.sf_type_id}`
            }
        })

        /**
         * Llama al ws de insertar o actualizar según la acción que se vaya a realizar
         *
         */
        async function sendForm () {
            switch (props.action) {
                case "insert":
                    await insertNewSFType()
                    break;
                case "update":
                    await updateSFType()
                    break;
            }
        }

        /**
         * Inserta una nueva agrupación
         *
         */
        async function insertNewSFType() {
            form_errors.value = {}
            loading.value = true

            if (validateData()){
                let response = await manageWSResponses(insertSFTypeWS, [sf_type_data.value.name, sf_type_data.value.active])

                if (response){
                    showNotification('success', 'Se ha insertado un nuevo tipo de fuerza de ventas')
                    await props.reloadData()
                    props.open_modal()
                }
            }
            loading.value = false
        }

        /**
         * Actualiza una agrupación
         *
         */
        async function updateSFType() {
            loading.value = true

            if (validateData()){
                let response = await manageWSResponses(updateSFTypeWS, [sf_type_data.value.sf_type_id, sf_type_data.value.name, sf_type_data.value.active])

                if (response){
                    showNotification('success', response.data)
                    await props.reloadData()
                    props.open_modal()
                }
            }

            loading.value = false
        }

        /**
         * Valida que los campos de nombre y manager esten rellenos
         *
         * @return {boolean} True si ambos campos están rellenos, false si alguno no lo está
         */
        function validateData() {
            let correct = true
            form_errors.value = {}

            if (!variableIsDefined(sf_type_data.value.name)){
                form_errors.value.name = true
                correct = false
            }

            return correct
        }

        return {
            sendForm,

            modal_title,
            form_errors,
            sf_type_data,
            loading,
        }
    }
}
</script>

<style lang="scss">

.custom-height {
    min-height: 28vh !important
}

</style>